import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const app = document.getElementById("root");
if (!app) throw new Error("Failed to find the root element");
const rootElement = createRoot(app);

rootElement.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
